import firebase from "firebase/app";
import { readable } from "svelte/store";
import { userStore } from "./auth";
const createDb = (data) => {
    const aByID = new Map(data.reduce((memo, b) => {
        const next = b.accounts.map((a) => [a.id, a]);
        memo = [...memo, ...next];
        return memo;
    }, []));
    return {
        budgetsById: new Map(data.map((b) => [b.id, b])),
        accountsById: aByID,
    };
};
const getBudgetsAndAccounts = async () => {
    try {
        const fromSessionStorage = sessionStorage.getItem("BUDGETS_AND_ACCOUNTS");
        const data = JSON.parse(fromSessionStorage);
        if (!Array.isArray(data)) {
            throw new Error("not array");
        }
        return data;
    }
    catch (e) {
        const httpsGetBudgets = firebase
            .functions()
            .httpsCallable("getBudgetsAndAcounts");
        const data = await httpsGetBudgets().then((a) => a.data);
        sessionStorage.setItem("BUDGETS_AND_ACCOUNTS", JSON.stringify(data));
        return data;
    }
};
const budgetsAndAccounts = readable({ type: "LOADING" }, (set) => {
    return userStore.subscribe((user) => {
        if (user) {
            getBudgetsAndAccounts()
                .then((a) => {
                set({
                    type: "LOADED",
                    data: a,
                    db: createDb(a),
                });
            })
                .catch((e) => {
                set({
                    type: "ERROR",
                    message: e.message,
                });
            });
        }
    });
});
export { budgetsAndAccounts };
